module.exports = __webpack_public_path__ + "static/euforia2-84fcf0e57cf24cc3230b39e5ee036ae2.png";